export default {
  zoom: 5.2,
  position: {
    lat: 43.6531,
    lng: -79.3839,
  },
};
